import loadJSON from "./loadJSON";

const publicApi = loadJSON(`${process.env.PUBLIC_URL}/api/api.json`);
const BASE_URL = publicApi.BASE_URL;
const BASE_URL_EMAIL_SENDER = publicApi.BASE_URL_EMAIL_SENDER;

// Login
const APP_SECURITY_TOKEN = publicApi.APP_SECURITY_TOKEN;
const SSO_CODE = publicApi.SSO_CODE;
const SSO_LOGOUT = publicApi.SSO_LOGOUT;
const storedValue = sessionStorage.getItem("appId");
const ENV = publicApi.ENV;
const LOGIN_APP_ID = publicApi.LOGIN_APP_ID;
const EXTERNAL_PAYMENTS = publicApi.EXTERNAL_PAYMENTS;
const KILLBILL_GUI_URL = publicApi.KILLBILL_GUI_URL;
let APP_ID = null;

if (storedValue && storedValue === 'DEFAULT') {
    const valuesArray = publicApi.DEFAULT_APP_IDS.split(',');
    APP_ID = Object.freeze(valuesArray);  
}else if (storedValue && storedValue !== '') {
    const valuesArray = storedValue.split(',');
    APP_ID = Object.freeze(valuesArray);  
}

// BFF
const DASHBOARD_BFF_LOGIN = BASE_URL+publicApi.DASHBOARD_BFF_LOGIN;
const DASHBOARD_BFF_API = BASE_URL + publicApi.DASHBOARD_BFF_API;
const DASHBOARD_BFF_SSO_LOGIN = BASE_URL + publicApi.DASHBOARD_BFF_SSO_LOGIN;
const DASHBOARD_BFF_LOGOUT = BASE_URL + publicApi.DASHBOARD_BFF_LOGOUT;
const DASHBOARD_BFF_CREDIT_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_CREDIT_API;
const DASHBOARD_BFF_PAGINATED_TRANSACTION_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_PAGINATED_TRANSACTION_API;
const DASHBOARD_TRANSACTION_IN_FILE_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_TRANSACTION_IN_FILE_DOWNLOAD;
const DASHBOARD_BFF_BULK_CSV_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_BFF_BULK_CSV_DOWNLOAD;
const DASHBOARD_BFF_SCT_CSV_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_BFF_SCT_CSV_DOWNLOAD;
const DASHBOARD_BFF_SCT_BULK_CSV_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_BFF_SCT_BULK_CSV_DOWNLOAD;
const DASHBOARD_BFF_DEBIT_CSV_DOWNLOAD = BASE_URL + publicApi.DASHBOARD_BFF_DEBIT_CSV_DOWNLOAD;

const DASHBOARD_BFF_TRANSACTION_DETAIL_API = BASE_URL+publicApi.API_VERSION_TRANSACTION_DETAIL+"/APP_ID"+publicApi.DASHBOARD_BFF_TRANSACTION_DETAIL_API;
const DASHBOARD_BFF_REFOUND_ON_TRANSACTION_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_REFOUND_ON_TRANSACTION_API;
const DASHBOARD_BFF_NEW_PAYMENT_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_NEW_PAYMENT_API;
const DASHBOARD_BFF_NEW_PAYMENT_API_V2 = BASE_URL+"/v2/APP_ID"+publicApi.DASHBOARD_BFF_NEW_PAYMENT_API;
const DASHBOARD_BFF_REFUND = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_REFUND;
const DASHBOARD_BFF_REFUND_V2 = BASE_URL+"/v2/api/APP_ID"+publicApi.DASHBOARD_BFF_REFUND;
const DASHBOARD_BFF_TRANSACTION_LOG_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_TRANSACTION_LOG_API; 
const DASHBOARD_BFF_ADD_USER_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_ADD_USER_API;
const DASHBOARD_BFF_EXPORT_USERS_DATA = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_EXPORT_USERS_DATA;
const DASHBOARD_BFF_DELETE_USER_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_DELETE_USER_API;
const DASHBOARD_BFF_RESET_USER_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_RESET_USER_API;
const DASHBOARD_BFF_CHANGE_PASSWORD_API = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_CHANGE_PASSWORD_API;
const DASHBOARD_BFF_DOWNLOAD_CSV = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_DOWNLOAD_CSV;
const DASHBOARD_BFF_GET_USERS = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_GET_USERS;
const DASHBOARD_BFF_PAYMENT_METHODS = BASE_URL+publicApi.DASHBOARD_BFF_PAYMENT_METHODS;
const DASHBOARD_BFF_PAYMENT_METHOD_UPDATE = BASE_URL+"/api/APP_ID"+publicApi.DASHBOARD_BFF_PAYMENT_METHOD_UPDATE;
const DASHBOARD_BFF_PAGINATED_SCHEDULE_API = BASE_URL+"/v2/APP_ID"+publicApi.DASHBOARD_BFF_GET_SCHEDULER;
const DASHBOARD_BFF_ADDITIONAL_FIELDS = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_ADDITIONAL_FIELDS;

/* BILLING */
const DASHBOARD_BFF_BILLING_CATALOG = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_CATALOG;
const DASHBOARD_BFF_BILLING_CATALOG_V2 = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_CATALOG_V2;
const DASHBOARD_BFF_BILLING_BOUNDLE = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_BOUNDLE;
const DASHBOARD_BFF_BILLING_SUBSCRIPTIONS = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_SUBSCRIPTIONS;
const DASHBOARD_BFF_BILLING_INVOICES = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_INVOICES;
const DASHBOARD_BFF_BILLING_ACCOUNT_BALANCE = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_ACCOUNT_BALANCE;
const DASHBOARD_BFF_BILLING_CREDIT_NOTES = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_CREDIT_NOTES;
const DASHBOARD_BFF_BILLING_CART_CHECKOUT = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_CART_CHECKOUT;
const DASHBOARD_BFF_BILLING_SUBSCRIPTION_BASE = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_SUBSCRIPTION_BASE;
const DASHBOARD_BFF_BILLING_CATALOG_DISCOUNTS = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_CATALOG_DISCOUNTS;
const DASHBOARD_BFF_BILLING_SUB_CUSTOM_FIELDS_BASE = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_SUB_CUSTOM_FIELDS_BASE;
const DASHBOARD_BFF_BILLING_INV_CUSTOM_FIELDS_BASE = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_INV_CUSTOM_FIELDS_BASE;
const DASHBOARD_BFF_BILLING_CN_CUSTOM_FIELDS_BASE = BASE_URL+publicApi.DASHBOARD_BFF_BILLING_CN_CUSTOM_FIELDS_BASE;

// BILLING - INVOICES actions
const DASHBOARD_BFF_BILLING_INVOICE_REVERSE = BASE_URL + "/billing/invoices/INVOICE_ID/reverse";
const DASHBOARD_BFF_BILLING_INVOICE_ADJUST_BY_ITEMS = BASE_URL + "/billing/invoices/INVOICE_ID/adjustByItems";

/* BILLING - INVOICES RELATED (by bookingReferenceCode) */
const DASHBOARD_BFF_BILLING_INVOICES_BY_BOOKING_REFERENCE_CODE = BASE_URL + "/billing/invoices/bookingReferenceCode/BOOKING_REFERENCE_CODE";

//CUSTOMER
const DASHBOARD_BFF_USER_REGISTRY_USERS = BASE_URL+publicApi.DASHBOARD_BFF_USER_REGISTRY_USERS;
const DASHBOARD_BFF_USER_REGISTRY_ADDITIONAL_INFO = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_USER_REGISTRY_ADDITIONAL_INFO;
const DASHBOARD_BFF_USER_REGISTRY_CREATE_USER = BASE_URL+publicApi.DASHBOARD_BFF_USER_REGISTRY_CREATE_USER;

//SEPA
const DASHBOARD_SEPA_SDD_SUMMARY = BASE_URL + publicApi.DASHBOARD_SEPA_SDD_SUMMARY;
const DASHBOARD_SEPA_SCT_SUMMARY = BASE_URL + publicApi.DASHBOARD_SEPA_SCT_SUMMARY;
const DASHBOARD_SEPA_SDD_OVERVIEW = BASE_URL + publicApi.DASHBOARD_SEPA_SDD_OVERVIEW;
const DASHBOARD_SEPA_SCT_OVERVIEW = BASE_URL + publicApi.DASHBOARD_SEPA_SCT_OVERVIEW;
const DASHBOARD_TRANSACTION_OUT_FILE_SDD = BASE_URL + publicApi.DASHBOARD_TRANSACTION_OUT_FILE_SDD;
const DASHBOARD_BFF_PAGINATED_BULK_SDD_API = BASE_URL + publicApi.DASHBOARD_BFF_PAGINATED_BULK_SDD_API;
const DASHBOARD_BFF_PAGINATED_SDD_DEBIT_API = BASE_URL + publicApi.DASHBOARD_BFF_PAGINATED_SDD_DEBIT_API;
const DASHBOARD_BFF_SDD_DEBIT_DETAIL_API = BASE_URL + publicApi.DASHBOARD_BFF_SDD_DEBIT_DETAIL_API;
const DASHBOARD_BFF_SDD_BULK_DETAIL_API = BASE_URL + publicApi.DASHBOARD_BFF_SDD_BULK_DETAIL_API;
const DASHBOARD_BFF_PAGINATED_SCT_CREDIT_API = BASE_URL + publicApi.DASHBOARD_BFF_PAGINATED_SCT_CREDIT_API;
const DASHBOARD_BFF_SCT_CREDIT_DETAIL_API = BASE_URL+publicApi.DASHBOARD_BFF_SCT_CREDIT_DETAIL_API;
const DASHBOARD_SDD_FILE_LIST = BASE_URL+publicApi.DASHBOARD_SDD_FILE_LIST;
const DASHBOARD_DOWNLOAD_BULK_SCT = BASE_URL+publicApi.DASHBOARD_DOWNLOAD_BULK_SCT;
const DASHBOARD_DOWNLOAD_SCT_FILE = BASE_URL+publicApi.DASHBOARD_DOWNLOAD_SCT_FILE;
const DASHBOARD_SCT_FILE_LIST = BASE_URL+publicApi.DASHBOARD_SCT_FILE_LIST;
const DASHBOARD_BFF_PAGINATED_SCT_CREDIT_BULK_API = BASE_URL+publicApi.DASHBOARD_BFF_PAGINATED_SCT_CREDIT_BULK_API;
const DASHBOARD_SCT_BULK_DETAIL = BASE_URL+publicApi.DASHBOARD_SCT_BULK_DETAIL;

//EMAILSENDER
const DASHBOARD_EMAIL_SENDER_MAILS = BASE_URL_EMAIL_SENDER+"/APP_ID"+publicApi.DASHBOARD_EMAIL_SENDER_MAILS;
const DASHBOARD_EMAIL_SENDER_TEMPLATES = BASE_URL_EMAIL_SENDER+"/APP_ID"+publicApi.DASHBOARD_EMAIL_SENDER_TEMPLATES;

//RECONCILIATOR
const DASHBOARD_RECONCILIATOR_SUMMARY = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_SUMMARY;
const DASHBOARD_RECONCILIATOR_FILE_LIST = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_FILE_LIST;
const DASHBOARD_RECONCILIATOR_FILE_DETAIL = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_FILE_DETAIL;
const DASHBOARD_RECONCILIATOR_TRANSACTION_LIST = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_TRANSACTION_LIST;
const DASHBOARD_RECONCILIATOR_TRANSACTION_ACQUIRER_DETAIL = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_TRANSACTION_ACQUIRER_DETAIL;
const DASHBOARD_RECONCILIATOR_FORCING = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_FORCING;
const DASHBOARD_RECONCILIATOR_PROCESSOR_TRANSACTION = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_PROCESSOR_TRANSACTION;
const DASHBOARD_RECONCILIATOR_DATES = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_DATES;
const DASHBOARD_RECONCILIATOR_SUMMARY_LIST = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_RECONCILIATOR_SUMMARY_LIST;

//CONFIG
const DASHBOARD_CONFIG_GET_KEYS = BASE_URL+publicApi.DASHBOARD_CONFIG_GET_KEYS;
const DASHBOARD_CONFIG_REFRESH = BASE_URL+publicApi.DASHBOARD_CONFIG_REFRESH;
const DASHBOARD_CONFIG_ADDITIONAL_FIELDS = BASE_URL+publicApi.DASHBOARD_CONFIG_ADDITIONAL_FIELDS;

//STATISTICS
const DASHBOARD_STATISTICS = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_STATISTICS;

//VOP
const DASHBOARD_VOP = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_VOP;

//CHATBOT
const DASHBOARD_CHATBOT = BASE_URL/*+/APP_ID*/+publicApi.DASHBOARD_BFF_CHATBOT;

//PRODUCTS
const DASHBOARD_BFF_GET_PRODUCTS = BASE_URL+"/APP_ID"+publicApi.DASHBOARD_BFF_PRODUCTS;
export {
    DASHBOARD_BFF_API,BASE_URL,DASHBOARD_BFF_CREDIT_API,ENV,LOGIN_APP_ID,EXTERNAL_PAYMENTS,DASHBOARD_BFF_LOGIN,DASHBOARD_BFF_TRANSACTION_DETAIL_API,DASHBOARD_BFF_PAGINATED_SCT_CREDIT_API,
    DASHBOARD_BFF_PAGINATED_TRANSACTION_API, DASHBOARD_TRANSACTION_IN_FILE_DOWNLOAD, DASHBOARD_TRANSACTION_OUT_FILE_SDD, DASHBOARD_BFF_PAGINATED_BULK_SDD_API,
    DASHBOARD_BFF_NEW_PAYMENT_API,DASHBOARD_BFF_TRANSACTION_LOG_API,DASHBOARD_BFF_ADD_USER_API,DASHBOARD_BFF_EXPORT_USERS_DATA,DASHBOARD_BFF_DELETE_USER_API,DASHBOARD_BFF_REFOUND_ON_TRANSACTION_API,
    DASHBOARD_BFF_RESET_USER_API,DASHBOARD_BFF_CHANGE_PASSWORD_API,DASHBOARD_BFF_REFUND,DASHBOARD_BFF_REFUND_V2,DASHBOARD_BFF_DOWNLOAD_CSV,DASHBOARD_BFF_GET_USERS, DASHBOARD_BFF_SDD_DEBIT_DETAIL_API,
    APP_SECURITY_TOKEN,DASHBOARD_EMAIL_SENDER_MAILS,DASHBOARD_EMAIL_SENDER_TEMPLATES,DASHBOARD_RECONCILIATOR_FILE_LIST,DASHBOARD_RECONCILIATOR_TRANSACTION_LIST, 
    DASHBOARD_RECONCILIATOR_SUMMARY,DASHBOARD_RECONCILIATOR_FILE_DETAIL,DASHBOARD_RECONCILIATOR_TRANSACTION_ACQUIRER_DETAIL,DASHBOARD_RECONCILIATOR_FORCING, APP_ID,
    DASHBOARD_RECONCILIATOR_PROCESSOR_TRANSACTION,DASHBOARD_RECONCILIATOR_DATES,DASHBOARD_CONFIG_GET_KEYS,DASHBOARD_CONFIG_REFRESH,DASHBOARD_SDD_FILE_LIST, SSO_CODE,SSO_LOGOUT,
    DASHBOARD_BFF_LOGOUT,DASHBOARD_RECONCILIATOR_SUMMARY_LIST,DASHBOARD_BFF_SSO_LOGIN,DASHBOARD_BFF_SCT_CSV_DOWNLOAD, DASHBOARD_BFF_BULK_CSV_DOWNLOAD, DASHBOARD_BFF_SCT_BULK_CSV_DOWNLOAD, DASHBOARD_BFF_DEBIT_CSV_DOWNLOAD,
    DASHBOARD_BFF_PAGINATED_SDD_DEBIT_API,DASHBOARD_BFF_SDD_BULK_DETAIL_API,DASHBOARD_BFF_SCT_CREDIT_DETAIL_API,DASHBOARD_DOWNLOAD_BULK_SCT,DASHBOARD_DOWNLOAD_SCT_FILE,
    DASHBOARD_SCT_FILE_LIST,DASHBOARD_BFF_PAGINATED_SCT_CREDIT_BULK_API,DASHBOARD_SCT_BULK_DETAIL,DASHBOARD_SEPA_SDD_SUMMARY,DASHBOARD_SEPA_SCT_SUMMARY, DASHBOARD_SEPA_SDD_OVERVIEW, DASHBOARD_SEPA_SCT_OVERVIEW,
    DASHBOARD_BFF_USER_REGISTRY_USERS,DASHBOARD_BFF_USER_REGISTRY_CREATE_USER,DASHBOARD_BFF_USER_REGISTRY_ADDITIONAL_INFO,DASHBOARD_BFF_BILLING_CATALOG,DASHBOARD_BFF_BILLING_BOUNDLE,DASHBOARD_BFF_BILLING_SUBSCRIPTIONS,DASHBOARD_BFF_BILLING_INVOICES,
    DASHBOARD_BFF_BILLING_ACCOUNT_BALANCE,DASHBOARD_BFF_BILLING_CREDIT_NOTES,DASHBOARD_BFF_BILLING_CART_CHECKOUT,DASHBOARD_BFF_BILLING_SUBSCRIPTION_BASE,DASHBOARD_BFF_BILLING_CATALOG_DISCOUNTS,DASHBOARD_BFF_BILLING_CATALOG_V2,
    DASHBOARD_BFF_BILLING_SUB_CUSTOM_FIELDS_BASE,DASHBOARD_BFF_BILLING_INV_CUSTOM_FIELDS_BASE,DASHBOARD_BFF_BILLING_CN_CUSTOM_FIELDS_BASE,
    DASHBOARD_BFF_BILLING_INVOICE_REVERSE, DASHBOARD_BFF_BILLING_INVOICE_ADJUST_BY_ITEMS,
    DASHBOARD_BFF_BILLING_INVOICES_BY_BOOKING_REFERENCE_CODE,
    DASHBOARD_BFF_PAYMENT_METHODS,DASHBOARD_BFF_PAYMENT_METHOD_UPDATE,DASHBOARD_BFF_PAGINATED_SCHEDULE_API,DASHBOARD_STATISTICS,DASHBOARD_VOP,DASHBOARD_CHATBOT, DASHBOARD_BFF_GET_PRODUCTS,DASHBOARD_BFF_NEW_PAYMENT_API_V2,
    DASHBOARD_CONFIG_ADDITIONAL_FIELDS,DASHBOARD_BFF_ADDITIONAL_FIELDS,KILLBILL_GUI_URL
};
